/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=77bf9fde&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=77bf9fde&scoped=true&lang=scss"
import "./App.vue?vue&type=style&index=1&id=77bf9fde&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77bf9fde"]])

export default __exports__